module.exports = __webpack_public_path__ + "static/media/Arrow.883f812d.png";